import request from "@/utlis/request";

export function findSysUsersPage(data) {
    return request({
        url: "/admin/sysuser/findSysUsersPage",
        method: "POST",
        data,
    });
}

/**
 * 新增用户(如果传id是编辑，不传是保存)
 */
export function saveSysUser(data) {
    return request({
        url: "/admin/sysuser/saveSysUser",
        method: "POST",
        data,
    });
}

/**
 * 查询机构列表
 */
export function findAllInstitution(data) {
    return request({
        url: "/admin/institution/findAllInstitution",
        method: "post",
        data,
    });
}

/**
 * 根据id查询用户详情
 */
export function findSysUserById(id) {
    return request({
        url: "/admin/sysuser/findSysUserById",
        method: "get",
        params: {
            id,
        },
    });
}

/**
 * 批量禁用/启用
 */
export function batchUpdateStatus(data) {
    return request({
        url: "/admin/sysuser/batchUpdateStatus",
        method: "post",
        data,
    });
}

/**
 * 重置密码
 */
export function resetPassword(data) {
    return request({
        url: "/admin/sysuser/resetPassword",
        method: "post",
        data,
    });
}

/**
 * 批量删除
 */
export function deleteSysUser(data) {
    return request({
        url: "/admin/sysuser/deleSysUser",
        method: "post",
        data,
    });
}


export function addOrSubNum(params) {
    return request({
        url: "/admin/sysuser/addOrSubNum",
        method: "get",
        params: params
    });
}

export function addDJLog(params) {
    return request({
        url: "/admin/sysuser/addDJLog",
        method: "get",
        params: params
    });
}

export function getDJLogList(params) {
    return request({
        url: "/admin/sysuser/getDJLogList",
        method: "get",
        params: params
    });
}


export function getUserCZList(data) {
    return request({
        url: "/admin/sysuser/getUserCZList",
        method: "POST",
        data,
    });
}

export function findSysUserByUserName(name) {
    return request({
        url: "/admin/sysuser/findSysUserByUserName",
        method: "get",
        params: {
            username: name
        },
    });
}

export function addUserCZLog(data) {
    return request({
        url: "/admin/sysuser/addUserCZLog",
        method: "POST",
        data,
    });
}


export function getUserCZById(param) {
    return request({
        url: "/admin/sysuser/getUserCZById",
        method: "GET",
        params: param,
    });
}


export function updateUserCZById(param) {
    return request({
        url: "/admin/sysuser/updateUserCZById",
        method: "GET",
        params: param,
    });
}

export function tkUserCZById(param) {
    return request({
        url: "/admin/sysuser/tkUserCZById",
        method: "GET",
        params: param,
    });
}
export function getUserCPJList(data) {
    return request({
        url: "/admin/sysuser/getUserCPJList",
        method: "POST",
        data,
    });
}



export function addUserCPJLog(data) {
    return request({
        url: "/admin/sysuser/addUserCPJLog",
        method: "POST",
        data,
    });
}


export function getUserCPJById(param) {
    return request({
        url: "/admin/sysuser/getUserCPJById",
        method: "GET",
        params: param,
    });
}


export function updateUserCPJById(param) {
    return request({
        url: "/admin/sysuser/updateUserCPJById",
        method: "GET",
        params: param,
    });
}

export function tkUserCPJById(param) {
    return request({
        url: "/admin/sysuser/tkUserCPJById",
        method: "GET",
        params: param,
    });
}


